/**
 * Internal cross-link paths for the B2B marketing pages. Centralised so the
 * URLs can be changed in one place — the pages themselves are URL-agnostic
 * components.
 *
 * The B2B pages are served at the real root paths on the business subdomain
 * (host-based routing inside Remix — see `app/utils/request.server.ts`
 * `isBusinessHost` and `app/modules/b2b/BUSINESS_SUBDOMAIN.md`):
 *   business.archiproamerica.com/                → B2B index
 *   business.archiproamerica.com/brands          → B2B brands
 *   business.archiproamerica.com/professionals   → B2B professionals
 */
export const B2B_BRANDS_PATH = '/brands';
export const B2B_PROFS_PATH = '/professionals';
